module.exports = __webpack_public_path__ + "img/up-arrow.eb9eeb16.svg";